export interface StorageHealthSnapshot {
  status: 'ok' | 'warning' | 'error'
  kind: 'generic' | 'revision-conflict' | null
  message: string | null
  failedAt: string | null
  recovery: { label: string; run: () => void } | null
}

type Listener = () => void

let snapshot: StorageHealthSnapshot = {
  status: 'ok',
  kind: null,
  message: null,
  failedAt: null,
  recovery: null,
}

const listeners = new Set<Listener>()

function emit() {
  for (const listener of listeners) listener()
}

export const storageHealth = {
  getSnapshot(): StorageHealthSnapshot {
    return snapshot
  },
  subscribe(listener: Listener) {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
  reportFailure(message: string) {
    snapshot = {
      status: 'error',
      kind: 'generic',
      message,
      failedAt: new Date().toISOString(),
      recovery: null,
    }
    emit()
  },
  reportWarning(message: string) {
    snapshot = {
      status: 'warning',
      kind: 'generic',
      message,
      failedAt: new Date().toISOString(),
      recovery: null,
    }
    emit()
  },
  reportConflict(reload = () => window.location.reload()) {
    snapshot = {
      status: 'warning',
      kind: 'revision-conflict',
      message: '另一个标签页已保存更新。当前更改未保存，请加载最新数据后重试。',
      failedAt: new Date().toISOString(),
      recovery: { label: '加载最新数据并重试', run: reload },
    }
    emit()
  },
  clear() {
    snapshot = { status: 'ok', kind: null, message: null, failedAt: null, recovery: null }
    emit()
  },
}
